import React from "react";

// Contenu du tutoriel de la vue d'ensemble "Bureau" — un jeu de steps
// différent selon le profil actif (Comptable / Gestion de paie /
// Secrétariat-Direction / Juridique), affiché par le composant générique
// TutorialOverlay (src/components/ui/TutorialOverlay.js). Même format que
// TraitementsComptablesTutorial.js (image + title + legende + description).
//
// Les champs "image" et "legende" sont volontairement vides pour l'instant
// (chaque profil aura son propre tutoriel détaillé avec captures d'écran,
// slide par slide, plus tard) — remplacer "image" par le lien Vercel Blob de
// la capture correspondante dès qu'elle est disponible, et "legende" par sa
// légende le cas échéant. TutorialOverlay masque automatiquement le bloc
// image tant que "image" est vide.
const bureauTutorials = {
  comptable: [
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092400.png",
      title: "Bienvenue dans le Bureau",
      legende: "",
      description: (
        <>
          Le Bureau est votre <strong>cockpit personnel</strong> : un écran
          d'ensemble qui réunit, au même endroit, l'essentiel de votre
          activité du jour — indicateurs, priorités, rendez-vous et
          raccourcis vers vos outils.
          <br />
          <br />
          Il ne remplace aucun écran existant : chaque élément affiché ici{" "}
          <strong>renvoie directement</strong> vers l'écran correspondant
          (ToDo, Agenda, Feuille de temps...) — le Bureau est un point de
          départ, pas une nouvelle saisie.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092426.png",
      title: "Les indicateurs en haut de page",
      legende: "",
      description: (
        <>
          Les tuiles en haut de l'écran résument, en un chiffre, les points
          clés de votre activité : <strong>votre portefeuille</strong>{" "}
          (nombre de tâches suivies), vos{" "}
          <strong>tâches en cours et en retard</strong>, et votre{" "}
          <strong>TVA mensuelle en retard</strong> sur vos dossiers, pour le
          mois en cours.
          <br />
          <br />
          Cliquez sur une tuile pour être redirigé directement vers l'écran
          correspondant.
          <br />
          <br />
          Une dernière tuile, <strong>« Suggérer une idée »</strong>, vous
          permet à tout moment de proposer{" "}
          <strong>un indicateur ou une information à
          afficher</strong> — n'hésitez pas à vous en servir.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092717.png",
      title: "Ma file de priorité",
      legende: "",
      description: (
        <>
          Cette liste reprend <strong>vos todos</strong> (écran ToDo), triés
          par échéance — les plus urgents en premier.
          <br />
          <br />
          Cliquez sur un élément pour l'ouvrir directement dans ToDo, ou
          cochez-le pour le <strong>clôturer sans quitter le Bureau</strong>.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092735.png",
      title: "Mes tâches en cours et en retard",
      legende: "",
      description: (
        <>
          Ce bloc reprend uniquement vos todos <strong>en cours</strong> ou
          déjà <strong>en retard</strong> — un raccourci pour repérer
          rapidement ce qui presse, sans avoir à filtrer l'écran ToDo.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092751.png",
      title: "Mes rendez-vous à venir",
      legende: "",
      description: (
        <>
          Ce bloc affiche vos <strong>prochains rendez-vous</strong> — vos
          RDV internes (Planning) et, si connecté, votre{" "}
          <strong>Google Calendar</strong> — pour un résumé rapide, sans
          ouvrir l'Agenda.
          <br />
          <br />
          Cliquez sur « Tout voir » pour ouvrir l'Agenda complet.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20093527.png",
      title: "Les raccourcis",
      legende: "",
      description: (
        <>
          Les raccourcis à droite donnent un accès direct à vos outils du
          quotidien : <strong>Mails</strong> (votre compte Gmail connecté),{" "}
          <strong>Agenda</strong> (votre Google Calendar et vos rendez-vous
          internes), <strong>Feuille de temps</strong> pour déclarer les
          tâches que vous réalisez chaque jour, et <strong>Congés</strong>{" "}
          pour vos demandes d'absence.
          <br />
          <br />
          La <strong>Messagerie</strong> interne est indiquée « bientôt
          disponible » — pas encore active.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092817.png",
      title: "Vos notes",
      legende: "",
      description: (
        <>
          L'encart Notes vous permet de <strong>noter un rappel</strong>{" "}
          personnel — une tâche à ne pas oublier, une information à garder
          sous les yeux — directement depuis le Bureau.
        </>
      ),
    },
  ],
  paie: [
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20094338.png",
      title: "Bienvenue dans le Bureau",
      legende: "",
      description: (
        <>
          Le Bureau est votre <strong>cockpit personnel</strong> : un écran
          d'ensemble qui réunit, au même endroit, l'essentiel de votre
          activité du jour — indicateurs, priorités, rendez-vous et
          raccourcis vers vos outils.
          <br />
          <br />
          Il ne remplace aucun écran existant : chaque élément affiché ici{" "}
          <strong>renvoie directement</strong> vers l'écran correspondant
          (Suivi Social, Agenda, Feuille de temps...) — le Bureau est un
          point de départ, pas une nouvelle saisie.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20094356.png",
      title: "Les indicateurs en haut de page",
      legende: "",
      description: (
        <>
          Les tuiles en haut de l'écran résument, en un chiffre, les points
          clés de votre activité : les <strong>BS à préparer</strong> et les{" "}
          <strong>DSN à transmettre</strong> ce mois-ci (tous dossiers
          confondus), ainsi que le nombre de{" "}
          <strong>dossiers paie actifs</strong>.
          <br />
          <br />
          Cliquez sur une tuile pour être redirigé directement vers Suivi
          Social.
          <br />
          <br />
          Une dernière tuile, <strong>« Suggérer une idée »</strong>, vous
          permet à tout moment de proposer{" "}
          <strong>un indicateur ou une information à
          afficher</strong> — n'hésitez pas à vous en servir.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20094405.png",
      title: "Ma file paie du mois",
      legende: "",
      description: (
        <>
          Cette liste reprend, tous dossiers confondus, les{" "}
          <strong>bulletins de salaire encore à préparer</strong> et les{" "}
          <strong>DSN encore à transmettre</strong> ce mois-ci — les DSN
          affichent une échéance au 5 du mois.
          <br />
          <br />
          Cliquez sur un élément pour ouvrir directement Suivi Social sur le
          dossier concerné.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20094423.png",
      title: "Événements sociaux récents",
      legende: "",
      description: (
        <>
          Ce bloc reprend les <strong>5 derniers événements saisis</strong>,
          toutes catégories confondues (DPAE, contrat de travail, rupture,
          attestation...), tous dossiers — un raccourci pour voir ce qui
          vient d'être enregistré sans ouvrir Suivi Social.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092751.png",
      title: "Mes rendez-vous à venir",
      legende: "",
      description: (
        <>
          Ce bloc affiche vos <strong>prochains rendez-vous</strong> — vos
          RDV internes (Planning) et, si connecté, votre{" "}
          <strong>Google Calendar</strong> — pour un résumé rapide, sans
          ouvrir l'Agenda.
          <br />
          <br />
          Cliquez sur « Tout voir » pour ouvrir l'Agenda complet.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20093527.png",
      title: "Les raccourcis",
      legende: "",
      description: (
        <>
          Les raccourcis à droite donnent un accès direct à vos outils du
          quotidien : <strong>Mails</strong> (votre compte Gmail connecté),{" "}
          <strong>Agenda</strong> (votre Google Calendar et vos rendez-vous
          internes), <strong>Feuille de temps</strong> pour déclarer les
          tâches que vous réalisez chaque jour, et <strong>Congés</strong>{" "}
          pour vos demandes d'absence.
          <br />
          <br />
          La <strong>Messagerie</strong> interne est indiquée « bientôt
          disponible » — pas encore active.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092817.png",
      title: "Vos notes",
      legende: "",
      description: (
        <>
          L'encart Notes vous permet de <strong>noter un rappel</strong>{" "}
          personnel — une tâche à ne pas oublier, une information à garder
          sous les yeux — directement depuis le Bureau.
        </>
      ),
    },
  ],
  secretariat: [
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20113647.png",
      title: "Bienvenue dans le Bureau",
      legende: "",
      description: (
        <>
          Le Bureau est votre <strong>cockpit personnel</strong> : un écran
          d'ensemble qui réunit, au même endroit, l'essentiel de votre
          activité du jour — priorités, rendez-vous et raccourcis vers vos
          outils.
          <br />
          <br />
          Il ne remplace aucun écran existant : chaque élément affiché ici{" "}
          <strong>renvoie directement</strong> vers l'écran correspondant
          (Agenda, Feuille de temps...) — le Bureau est un point de départ,
          pas une nouvelle saisie.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20113700.png",
      title: "Suggérer une idée",
      legende: "",
      description: (
        <>
          Contrairement aux autres profils, cette zone n'affiche pas
          d'indicateurs chiffrés : elle laisse la place à{" "}
          <strong>4 tuiles « Suggérer une idée »</strong>.
          <br />
          <br />
          Cliquez sur l'une d'elles à tout moment pour proposer{" "}
          <strong>un indicateur ou une information à
          afficher</strong> — n'hésitez pas à vous en servir.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20113715.png",
      title: "Accueil & rendez-vous",
      legende: "",
      description: (
        <>
          Cette liste fusionne trois sources : vos{" "}
          <strong>rendez-vous internes</strong> (Planning), votre{" "}
          <strong>Google Calendar</strong> si connecté, et les{" "}
          <strong>rendez-vous prospects</strong> à venir — triés par date,
          les plus proches en premier.
          <br />
          <br />
          Cliquez sur un rendez-vous interne ou Google Calendar pour ouvrir
          l'Agenda, ou sur un rendez-vous prospect pour ouvrir l'écran
          Prospects.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20113724.png",
      title: "Prospects — RDV à venir",
      legende: "",
      description: (
        <>
          Ce bloc reprend vos <strong>prochains rendez-vous prospects</strong>{" "}
          (jusqu'à 8), avec un compte à rebours — « Aujourd'hui » ou « J-3 »
          par exemple — pour repérer rapidement les rendez-vous les plus
          proches.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092751.png",
      title: "Rendez-vous du cabinet",
      legende: "",
      description: (
        <>
          Ce bloc est spécifique au profil Secrétariat / Direction : il
          affiche <strong>vos propres rendez-vous</strong> ainsi que ceux
          des <strong>collègues qui vous ont partagé leur planning</strong>{" "}
          — pas seulement les vôtres, contrairement aux autres profils.
          <br />
          <br />
          Cliquez sur « Tout voir » pour ouvrir l'Agenda complet.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20093527.png",
      title: "Les raccourcis",
      legende: "",
      description: (
        <>
          Les raccourcis à droite donnent un accès direct à vos outils du
          quotidien : <strong>Mails</strong> (votre compte Gmail connecté),{" "}
          <strong>Agenda</strong> (votre Google Calendar et vos rendez-vous
          internes), <strong>Feuille de temps</strong> pour déclarer les
          tâches que vous réalisez chaque jour, et <strong>Congés</strong>{" "}
          pour vos demandes d'absence.
          <br />
          <br />
          La <strong>Messagerie</strong> interne est indiquée « bientôt
          disponible » — pas encore active.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092817.png",
      title: "Vos notes",
      legende: "",
      description: (
        <>
          L'encart Notes vous permet de <strong>noter un rappel</strong>{" "}
          personnel — une tâche à ne pas oublier, une information à garder
          sous les yeux — directement depuis le Bureau.
        </>
      ),
    },
  ],
  juriste: [
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20104818.png",
      title: "Bienvenue dans le Bureau",
      legende: "",
      description: (
        <>
          Le Bureau est votre <strong>cockpit personnel</strong> : un écran
          d'ensemble qui réunit, au même endroit, l'essentiel de votre
          activité du jour — indicateurs, priorités, rendez-vous et
          raccourcis vers vos outils.
          <br />
          <br />
          Il ne remplace aucun écran existant : chaque élément affiché ici{" "}
          <strong>renvoie directement</strong> vers l'écran correspondant
          (Suivi, Agenda, Feuille de temps...) — le Bureau est un point de
          départ, pas une nouvelle saisie.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20104826.png",
      title: "Les indicateurs en haut de page",
      legende: "",
      description: (
        <>
          Les tuiles en haut de l'écran résument, en un chiffre, les points
          clés de votre activité : vos{" "}
          <strong>missions ponctuelles en cours</strong>, le nombre d'
          <strong>AGO restant à faire</strong> sur l'exercice, et les{" "}
          <strong>formalités à régulariser</strong> (RCS / greffe).
          <br />
          <br />
          Une dernière tuile, <strong>« Suggérer une idée »</strong>, vous
          permet à tout moment de proposer{" "}
          <strong>un indicateur ou une information à
          afficher</strong> — n'hésitez pas à vous en servir.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20104838.png",
      title: "Mes missions juridiques ponctuelles",
      legende: "",
      description: (
        <>
          Cette liste reprend vos{" "}
          <strong>missions juridiques ponctuelles en cours</strong> (droit
          des sociétés, modifications, créations, radiations...), triées par
          échéance — les plus urgentes en premier.
          <br />
          <br />
          Cliquez sur un élément pour l'ouvrir directement dans Suivi &gt;
          Missions juridiques ponctuelles.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20104847.png",
      title: "Formalités récemment déposées",
      legende: "",
      description: (
        <>
          Ce bloc reprend les <strong>5 dernières missions</strong> dont la
          formalité a été <strong>déposée</strong>, triées par date de mise
          à jour — un raccourci pour voir ce qui vient d'être traité sans
          ouvrir Suivi &gt; Missions juridiques ponctuelles.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092751.png",
      title: "Mes rendez-vous à venir",
      legende: "",
      description: (
        <>
          Ce bloc affiche vos <strong>prochains rendez-vous</strong> — vos
          RDV internes (Planning) et, si connecté, votre{" "}
          <strong>Google Calendar</strong> — pour un résumé rapide, sans
          ouvrir l'Agenda.
          <br />
          <br />
          Cliquez sur « Tout voir » pour ouvrir l'Agenda complet.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20093527.png",
      title: "Les raccourcis",
      legende: "",
      description: (
        <>
          Les raccourcis à droite donnent un accès direct à vos outils du
          quotidien : <strong>Mails</strong> (votre compte Gmail connecté),{" "}
          <strong>Agenda</strong> (votre Google Calendar et vos rendez-vous
          internes), <strong>Feuille de temps</strong> pour déclarer les
          tâches que vous réalisez chaque jour, et <strong>Congés</strong>{" "}
          pour vos demandes d'absence.
          <br />
          <br />
          La <strong>Messagerie</strong> interne est indiquée « bientôt
          disponible » — pas encore active.
        </>
      ),
    },
    {
      image:
        "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20092817.png",
      title: "Vos notes",
      legende: "",
      description: (
        <>
          L'encart Notes vous permet de <strong>noter un rappel</strong>{" "}
          personnel — une tâche à ne pas oublier, une information à garder
          sous les yeux — directement depuis le Bureau.
        </>
      ),
    },
  ],
};

export default bureauTutorials;
